import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'employees/components/list/EmployeesActions';

const EmployeesListRow = ({ company, subcompany, employee, permissions, t, handleToggle }) => (
  <tr>
    <td>{employee.key}</td>
    <td>{employee.name}</td>
    <td>{employee.lastname}</td>
    <td>{employee.email}</td>
    <td>{employee.position}</td>
    <td className="text-center">{t(employee.active ? 'common.yes' : 'common.no')}</td>
    <td className="text-center">
      <Actions
        company={company}
        employee={employee}
        handleToggle={handleToggle}
        permissions={permissions}
        subcompany={subcompany}
      />
    </td>
  </tr>
);

export default translate()(EmployeesListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/list/EmployeesListRow.js